import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Find the main scroll container (used in AppLayout and AdminLayout)
    const scrollContainer = document.getElementById("main-scroll-container");

    if (scrollContainer) {
      // Scroll the container to top
      scrollContainer.scrollTop = 0;
    }

    // Also scroll window to top (for auth pages and other layouts)
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }, [pathname]);

  return null;
};

export default ScrollToTop;
